import { z } from 'zod';

import {
	SignOperationStatusV6,
	SignOperationTypeV6,
} from '../../../../../api/generated/cz.partners.bank.backofficegateway.signs.external';
import { createEnumArraySchema } from '../../../../../helpers/zod/createEnumArraySchema';

export const bankProductsAndServicesFilterFormSchema = z.object({
	operationType: z.enum(SignOperationTypeV6).optional(),
	operationStatuses: createEnumArraySchema(SignOperationStatusV6),
});

export type BankProductsAndServicesFilterForm = z.infer<
	typeof bankProductsAndServicesFilterFormSchema
>;
